import React from 'react'
import { navigate, RouteComponentProps } from '@reach/router'

import { Box, Stack, Text } from '@myxplor/stardust'
import { Container, Header, Content, Footer } from '~/layouts/ScrollableContentLayout'

import EmailIcon from '~/icons/Email'

type Props = RouteComponentProps

const ExpiredEmail = (props: Props) => {
  const message =
    (props.location?.state as { message?: string } | undefined)?.message ??
    'This account change email has expired. Please check your inbox for the most recent email we sent you.'

  const onBack = () => {
    history.replaceState(null, '', '/')
    navigate('/login')
  }

  return (
    <Container>
      <Header icon="close" onBack={onBack}>
        Account Change Email Expired
      </Header>

      <Content>
        <Stack align="center" space="xxlarge">
          <Box height={73} width={96}>
            <EmailIcon />
          </Box>
          <Stack space="small">
            <Text color="highestEmphasis" prefab="body">
              {message}
            </Text>
          </Stack>
        </Stack>
      </Content>
      <Footer />
    </Container>
  )
}

export default ExpiredEmail
